import { CellTable } from "@/atoms"
import { getDefaultColumnParams } from "@/helpers/table.helpers"
import { MoreTableCell } from "@/molecules/MoreTableCell"
import { AgentCell } from "../AgentCell"
import { ViolatedCell } from "../ViolatedCell"

export const getColumnsTab = () => {
  return [
    {
      title: "Agent",
      render: AgentCell,
      ...getDefaultColumnParams("name")
    },
    {
      title: "Environment",
      render: CellTable,
      ...getDefaultColumnParams("environment")
    },
    {
      title: "Application",
      render: MoreTableCell,
      ...getDefaultColumnParams("apps")
    },
    {
      title: "Violations",
      render: ViolatedCell,
      ...getDefaultColumnParams("violated")
    }
  ]
}
